import { Button, Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

export function Error404() {
  return (
    <>
      <br /><br />
      <Container fluid>
        <Row>
          <Col xs={0} md={1} xl={2} />
          <Col xs={12} md={10} xl={8} >
            <br />
            <h1 className="text-danger text-center" style={{ fontSize: 160 }}>404</h1>
            <h2 className="text-info text-center">page not found</h2>
            <br />
            <div className="text-center">
              <Button as={Link} to="/">back to main page</Button>
            </div>
          </Col>
          <Col xs={0} md={1} xl={2} />
        </Row>
      </Container>
    </>
  );
}
